"use strict";

exports.__esModule = true;
exports.ReportScreen = void 0;
exports.ReportScreenWithParams = ReportScreenWithParams;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _Core = require("../../Core");
var _App = require("../../App");
var _ReportCollection = require("../ReportCollection");
var _API = require("../../API");
var _Report = require("../Report/Report");
var _ReportDataProvider = require("../ReportDataProvider");
var _ReportNavbar = require("../ReportNavbar");
var _Device = require("../../Device");
var _ReportToolbar = require("../ReportToolbar/ReportToolbar");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _UI = require("../../../Utils/UI");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _reportViewHeight = require("./reportViewHeight");
var _dec, _dec2, _class, _ReportScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Under the modern UI the wrapper scrolls when the report is taller than the
// window (see reportViewHeight). A flex item will not shrink below its content
// unless told to, so the container and the wrapper both get min-height 0 or
// the report would push the whole screen past the window with nothing able
// to scroll. The body inside the wrapper is what gets measured, so the report
// is sized to the space beside the scrollbar, not under it.
var ReportContainer = _styledComponents["default"].div.withConfig({
  displayName: "ReportScreen__ReportContainer",
  componentId: "sc-1x2rdzb-0"
})(["flex:1;display:flex;flex-direction:column;padding:1rem;", ""], function (props) {
  return props.$scroll && (0, _styledComponents.css)(["min-height:0;"]);
});
var ReportWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ReportScreen__ReportWrapper",
  componentId: "sc-1x2rdzb-1"
})(["flex:1;", ""], function (props) {
  return props.$scroll && (0, _styledComponents.css)(["min-height:0;overflow:auto;"]);
});
var ReportScrollBody = _styledComponents["default"].div.withConfig({
  displayName: "ReportScreen__ReportScrollBody",
  componentId: "sc-1x2rdzb-2"
})(["height:100%;min-width:0;"]);

/**
 * Screen which shows an individual report.
 */
var ReportScreen = exports.ReportScreen = (_dec = _ReportCollection.ReportCollectionContext.withContext, _dec2 = _Device.DeviceListContext.withContext, _dec(_class = _dec2(_class = (0, _Core.withTranslator)(_class = (_ReportScreen = /*#__PURE__*/function (_Component) {
  function ReportScreen() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportScreen, _Component);
  var _proto = ReportScreen.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translator = _this$props.translator,
      reportCollection = _this$props.reportCollection,
      match = _this$props.match,
      devices = _this$props.devices,
      idProp = _this$props.id;
    var translate = translator.translate;
    var update = reportCollection.update;
    var id = idProp || match && match.params && match.params.id;
    var modern = Boolean(this.context && this.context.modern);
    var updateReportWidgetValue = function updateReportWidgetValue(config, path, fieldName, fieldValue) {
      var updatedConfig = (0, _ConfigurableLayout.updateFieldInLayoutElement)(config, path, fieldName, fieldValue);
      update(updatedConfig).then(function () {
        (0, _UI.showSuccessToaster)(translate("ReportScreen.save.success", "Successfully updated the report"));
      })["catch"](function (error) {
        console.error(error);
        (0, _UI.showErrorToaster)(translate("ReportScreen.save.error", "An error has occurred while updating the report"));
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
      collection: reportCollection,
      id: id
    }, function (_ref) {
      var _data$element, _data$element2;
      var data = _ref.data,
        error = _ref.error,
        reload = _ref.reload;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
          title: translate("ReportScreen.title.error", "Error Loading Report")
        }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: translate("ReportScreen.navbar.title.error", "Error Loading Report")
        }), /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        }));
      }
      if (!data) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
          title: translate("ReportScreen.loadingText", "Loading {id} ...", {
            id: id
          })
        }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: translate("ReportScreen.loadingText", "Loading {id} ...", {
            id: id
          })
        }), /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
      }
      var renderReport = function renderReport(_ref2) {
        var width = _ref2.width,
          height = _ref2.height;
        return /*#__PURE__*/_react["default"].createElement(_Report.Report, {
          config: data,
          width: width,
          height: (0, _reportViewHeight.reportViewHeight)(data, height, modern),
          updateLayout: updateReportWidgetValue
        });
      };
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: data.name,
        "data-testid": "ReportScreen"
      }, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutVisibility, {
        layoutRolesVisibilities: data == null || (_data$element = data.element) == null || (_data$element = _data$element.props) == null ? void 0 : _data$element.rolesVisibility,
        layoutUsersVisibilities: data == null || (_data$element2 = data.element) == null || (_data$element2 = _data$element2.props) == null ? void 0 : _data$element2.usersVisibility
      }, /*#__PURE__*/_react["default"].createElement(_ReportDataProvider.ReportDataProvider, {
        report: data
      }, /*#__PURE__*/_react["default"].createElement(_ReportNavbar.ReportNavbar, {
        report: data,
        devices: devices
      }), /*#__PURE__*/_react["default"].createElement(_ReportToolbar.ReportToolbar, {
        report: data,
        devices: devices,
        onReload: reload
      }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(ReportContainer, {
        "data-testid": "ReportScreen.Container",
        $scroll: modern
      }, /*#__PURE__*/_react["default"].createElement(ReportWrapper, {
        $scroll: modern
      }, modern ? /*#__PURE__*/_react["default"].createElement(ReportScrollBody, {
        "data-testid": "ReportScreen.ScrollBody"
      }, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, renderReport)) : /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, renderReport)))))));
    });
  };
  return ReportScreen;
}(_react.Component), _ReportScreen.contextType = _UiDesignContext.UiDesignContext, _ReportScreen.defaultProps = {
  translator: undefined,
  devices: undefined,
  reportCollection: undefined
}, _ReportScreen)) || _class) || _class) || _class);
/**
 * RR6-safe entry: read :id from the route instead of relying on injected match props.
 */
function ReportScreenWithParams(props) {
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  return /*#__PURE__*/_react["default"].createElement(ReportScreen, _extends({}, props, {
    id: id
  }));
}
ReportScreenWithParams.displayName = "ReportScreenWithParams";